// 現在の温度がしきい値を超えている、もしくは下回っているかを判定する
export default function isOverThreshold(
  currentTemp: number,
  thresholdLow: number,
  thresholdHigh: number
): boolean {
  return currentTemp < thresholdLow || currentTemp > thresholdHigh;
}
